export class Platform {
    private static openFinance: string = '2';
    private static totalBank: string = '1';

    public static getOpenFinance(): string {
        return this.openFinance;
    }

    public static getTotalBank(): string {
        return this.totalBank;
    }
    
}